import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';


import * as jsPDF from 'jspdf';

import $ from 'jquery';

import { Observable, Subscription } from 'rxjs';


import 'hammerjs'



import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

import { Title, HammerGestureConfig } from '@angular/platform-browser';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';




import { Stand } from 'src/app/entity/stand.model';
import { AppSettings } from 'src/app/service/app.setting';
import { ActivatedRoute } from '@angular/router';
import { FloorService } from 'src/app/service/floor.service';
import { ComposeMailComponent } from '../email/include/compose-mail/compose-mail.component';
import { Contact } from 'src/app/entity/Contact';
import { ProspectService } from 'src/app/service/prospect.service';
import { Prospect } from 'src/app/entity/prospect';
import { MailsService } from 'src/app/service/mails.service';
import { Client } from 'src/app/entity/exhibitor';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Anonyme } from 'src/app/entity/Anonyme';
import { FactureService } from 'src/app/service/facture.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-floor',
  templateUrl: './floor.component.html',
  styleUrls: ['./floor.component.css']
})
export class FloorComponent implements OnInit {

  visible: boolean;

  selectedStand: Stand;
  selectedList: string = "";
  selectedStandId: number
  selectedExhibitor: Anonyme
  // standsList: Observable<any[]>;
  stands: Stand[]
  allStands: Stand[]
  exposants: Anonyme[]
  standsOut: Stand[]
  scale: number;
  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  complete: boolean;
  ilot: string;
  superficieAmenage: number;
  superficieSemiAmenage: number;
  superficieNuAmenage: number;
  filteredOptions: Observable<string[]>;
  @ViewChild(ComposeMailComponent)
  private composeMailComponent: ComposeMailComponent;
  totalFactures: number;
  devise: string;
  totalPaiement: number;
  solde: number;
  isAdmin:boolean;
  typeStandsColor: any;
  urlPlan: string;
  constructor(private floorService: FloorService, private factureService: FactureService, private route: ActivatedRoute, private mailsService: MailsService,
    private exhibitorService: ExhibitorService,
    private titleService: Title) {
    titleService.setTitle("Plan");
this.urlPlan=environment.erpAdresse+"/edit-floor"
 


  }

  private routeSub: Subscription;

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }
  ngOnInit() {
    this.getAll("interne");
    this.getAllStans();
    this.getAllExhibitors()
    this.routeSub = this.route.params.subscribe(params => {
      //console.log(params) //log the entire params object
      //console.log(params['id']) //log the value of id

    });

    document.getElementById('pop').scrollIntoView({ behavior: 'smooth' });

    /* this.pinch=0;
     var pinchZoom = require('pinch-zoom')
     var el = document.querySelector('.chart')
     var pzoom = pinchZoom(el, {
       draggable: true,
       maxScale: 4
     })
     pzoom.on('end', function (x, y , scale) {
   this.pinch=500;
     })
 
 */
    // this.initEvents();
    //  this.deplacer(0, 500);

    //this.firestore.collection('stand').add(param)
    /*
       this.floorFireServiceService.getAllStands().subscribe(res => {
   
         this.standsList = res.map(item => {
           return {
             id: item.payload.doc.id,
             ...item.payload.doc.data()
           } as Stand
         } ) 
      // //console.log(JSON.stringify(this.standsList));
       
       
       });
    */

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    this.deplacer('pop');


    if(localStorage.getItem('currentRole').indexOf('admin')>-1)
    this.isAdmin=true;
  }
  getAllExhibitors() {
    this.exhibitorService.findAllExhibitors().subscribe(result => {
      this.exposants = result;
    })
  }
  getAllStans() {
    this.floorService.getAll().subscribe(result => {
      this.allStands = result;
     
    })
  }
  getReport(stands: Stand[]){
    this.superficieAmenage=0;
    this.superficieSemiAmenage=0;
    this.superficieNuAmenage=0;
    stands.forEach(element => {
if(element.standType=='Stand aménagé')
this.superficieAmenage+=  (element.width*element.height);
else if(element.standType=='Stand semi aménagé')
this.superficieSemiAmenage+=  (element.width*element.height);
else if(element.standType=='Stand nu')
this.superficieNuAmenage+=  (element.width*element.height);

    });


    

  }
  initD3(el) {
    var d3plus;
    var d3;
    d3plus.textwrap()
      .container(d3.select(el))
      .resize(true)
      .draw();
  }
  selectedColor: string;
  selectColor(selectedColor) {
    this.selectedColor = selectedColor;
  }

  onStandClick(stand: Stand) {
    this.selectedStandId = stand.idStand;
    this.selectedList = null;
    ///   this.selectedStand=stand;
    //console.log(document.getElementById(stand.idStand + '').style.backgroundColor);
if( this.typeStandsColor=='gris'){
      if (document.getElementById(stand.idStand + '').style.backgroundColor === 'rgb(204, 204, 204)')
      document.getElementById(stand.idStand + '').style.background = this.selectedColor;

    else
      document.getElementById(stand.idStand + '').style.background = "rgb(204, 204, 204)";
}


    this.selectedStand = stand;
    this.financeReporting(stand.idClient)


  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    /* this.standsList.forEach(element => {
       this.options.push(element[3])
     });*/
    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);

  }
  filteredStandsSingle: Stand[];
  filterStandSingle(event) {
    let query = event.query;

    this.filteredStandsSingle = this.filterStand(query, this.allStands);

  }
  filterStand(query, stands: Stand[]): Stand[] {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    for (let i = 0; i < stands.length; i++) {
      let stand = stands[i];
      if (stand.num.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(stand);
      }
    }
    return filtered;
  }

  selectExhibitor(client: Anonyme) {
    this.selectedStand = null;
    this.selectedList = client.text3;
    //console.log('this.selectedList' + this.selectedList);
    this.selectedStandId = null;
    this.deplacer(client.l2 + "")
  }
  selectStand(stand: Stand) {
    this.selectedStandId = stand.idStand;
    this.selectedList = null;
    this.selectedExhibitor = null;
    if (this.selectedStandId)
      this.deplacer(this.selectedStandId + "")
  }


  filteredExhibitorsSingle: Anonyme[];
  filterExhibitorSingle(event) {
    let query = event.query;

    this.filteredExhibitorsSingle = this.filterExhibitor(query, this.exposants);

  }
  filterExhibitor(query, exhibitors: Anonyme[]): Anonyme[] {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    for (let i = 0; i < exhibitors.length; i++) {
      let exhibitor = exhibitors[i];
      if (exhibitor.text1.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(exhibitor);
      }
    }
    return filtered;
  }
  getAll(color) {

    this.typeStandsColor=color;
    //console.log("standsList ");


    this.floorService.getAllInside(true).subscribe(result => {
      if (color == 'interne')
        this.stands = result;
      else if (color == 'code') {
        this.stands = [];
        result.forEach(element => {
          if (element.clientList)
            element.backgroundColor = "#00FF00";
          else
            element.backgroundColor = "#cccccc";
          this.stands.push(element)

        });
      }
      else if (color == 'gris') {
        this.stands = [];
        result.forEach(element => {
       
            element.backgroundColor = "#cccccc";
          this.stands.push(element)

        });
      }
      else if (color == 'materiel') {
        this.stands = [];
        result.forEach(element => {
          if (element.materiel)
            element.backgroundColor = "#FF0000";
          else
            element.backgroundColor = "#cccccc";
          this.stands.push(element)

        });
      }
      else if (color == 'type') {
        this.stands = [];
        result.forEach(element => {
          if (element.standType == "Stand aménagé")
            element.backgroundColor = "#00FF00";
          else if (element.standType == "Stand semi aménagé")
            element.backgroundColor = "#ffff00";
          else if (element.standType == "Stand nu")
            element.backgroundColor = "#FF0000";
          this.stands.push(element)

        });
      }
    })
    this.floorService.getAllInside(false).subscribe(result => {

      for (let index = 0; index < result.length; index++) {
        const stand = result[index];
        //console.log("stand" + JSON.stringify(stand));


      }


      if (color == 'interne')
        this.standsOut = result;
      else if (color == 'code') {
        this.standsOut = [];
        result.forEach(element => {
          if (element.clientList)
            element.backgroundColor = "#00FF00";
          else
            element.backgroundColor = "#cccccc";
          this.standsOut.push(element)

        });
      }
      else if (color == 'materiel') {
        this.standsOut = [];
        result.forEach(element => {
          if (element.materiel)
            element.backgroundColor = "#FF0000";
          else
            element.backgroundColor = "#cccccc";
          this.standsOut.push(element)

        });
      }
      else if (color == 'type') {
        this.standsOut = [];
        result.forEach(element => {
          if (element.standType == "Stand aménagé")
            element.backgroundColor = "#00FF00";
          else if (element.standType == "Stand semi aménagé")
            element.backgroundColor = "#ffff00";
          else if (element.standType == "Stand nu")
            element.backgroundColor = "#FF0000";
          this.standsOut.push(element)

        });
      }
    })
  }
  deplacer(id: string) {
    //console.log("id" + id);
    //   $("#draggable").draggable();
    //this.viewportScroller.scrollToPosition([10000, 1000]);
    setTimeout(() => {
      //console.log("id" + id);
      if (id && document.getElementById(id))
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' });

    }, 100);
  }



  update() {

    this.floorService.findAllUpdate().subscribe(res => {


      res.forEach(element => {
        element.leftL = element.leftL + 1540;
        element.topL = element.topL + 10;



     //   element.backgroundColor = "#cccccc"

        let param = JSON.parse(JSON.stringify(element));


        //console.log("add" + JSON.stringify(param));


      });
      window.alert('done')
      this.getAll("gris");
    });
  }

  save() {
    //  this.floorFireServiceService.updateStand(this.selectedStand.idStand,this.selectedStand);
  }

  name: any
  selected: any;
  selectAnimd(id) {
    //     $('html, body').animate({ 'zoom': 1.5  }, 400);
    //console.log("id " + id);
    this.selected = id;
    var height = window.innerHeight * 1.5;
    var width = window.innerWidth * 1.5;
    if (true) {

      if (document.getElementById(id)) {

        $('html, body').animate({
          scrollTop: $(document.getElementById(id)).offset().top - (height / 2), scrollLeft: $(document.getElementById(id)).offset().left - (width / 2)
        }, 900);

      }
    }
  }
  color(stand: Stand): string {
    let color = "#f5f5f5"
    if (stand.pavillon) {
      if (stand.pavillon == '2007')
        color = "#009246"
      else if (stand.pavillon == 'usa1988')
        color = "#3C3B6E"
      else if (stand.pavillon == 'gh5463')
        color = "#009246"
      else
        color = stand.backgroundColor
    }
    return color;
  }

  /*
    textStand(stand:Stand):String{
      let text:String
      if(this.scale>4){
  text=stand.namec+' '+ stand.remarque;
      }
      else
      {
        text=stand.namec ;
  
      }
      return text
    }
   */




  captureScreen() { 
   // this.deplacer( );
    var divHeight = $('.intro').height();
var divWidth = $('.intro').width();
var ratio = divHeight / divWidth;
    const html2canvas = require('html2canvas');
  let mailsService1:MailsService=this.mailsService;
   let composeMailComponent1:ComposeMailComponent=this.composeMailComponent;
    let uploadedFiles = []
    // 297, 420 const pdf = new jsPDF('l', 'mm',  [1000, 1700] );580, 380
    const pdf =new jsPDF('l', 'mm',  [1300, 1800]);

    const promises = $('.intro').map(function(index, element) {
        return new Promise(function(resolve, reject) {
              html2canvas(element, { allowTaint: false, logging: false })
                .then(function(canvas) {
                    resolve(canvas.toDataURL("image/png"));
                })
                .catch(function(error) {
                    reject('error in PDF page: ' + index);
                });
        });
    });
   
    Promise.all(promises).then(function(dataURLS) {
        //console.log(dataURLS);
let first=true;

        for (const ind in dataURLS) {
    
           if (dataURLS.hasOwnProperty(ind) && first) {

                //console.log("Page  "+ind);
              //    pdf.addImage(dataURLS[ind], 'PNG', 0, 0);

              var width = pdf.internal.pageSize.getWidth();    
              var height = pdf.internal.pageSize.getHeight();
              height = ratio * width;
              pdf.addImage(dataURLS[ind], 'JPEG', 0, 0,0, height+10,'','FAST');
            //  pdf.addImage( dataURLS[ind], 'PNG',  0, 0, 0, 0,'','FAST'  );
          //  pdf.save('myPage.pdf');
            pdf.addPage();
            }
            first=false;  
        }
        var pageCount = pdf.internal.getNumberOfPages();
   
pdf.deletePage(pageCount)
        pdf.save('floorPlan.pdf');
         let data:any = new Blob([pdf.output('blob')], {
          type: 'application/pdf' 
          
        });
        data .name="Floor_Plan_NAPEC2020.pdf"
        uploadedFiles.push(data);
        mailsService1.findodel(6).subscribe( result=>{
          composeMailComponent1.prepareEmailModel(result,new Contact(), "NAPEC",new Prospect(), uploadedFiles)
     });
   
})
}

  captureScreen1() {
    this.deplacer('pop');
    var divHeight = $('.intro1').height();
    var divWidth = $('.intro1').width();
    var ratio = divHeight / divWidth;
    const html2canvas = require('html2canvas');
    let mailsService1: MailsService = this.mailsService;
    let composeMailComponent1: ComposeMailComponent = this.composeMailComponent;
    let uploadedFiles = []
    // 297, 420 const pdf = new jsPDF('l', 'mm',  [1000, 1700] );580, 380
    const pdf = new jsPDF('l', 'mm', [1300, 1800]);

    const promises = $('.intro1').map(function (index, element) {
      return new Promise(function (resolve, reject) {
        html2canvas(element, { allowTaint: false, logging: false })
          .then(function (canvas) {
            resolve(canvas.toDataURL("image/png"));
          })
          .catch(function (error) {
            reject('error in PDF page: ' + index);
          });
      });
    });

    Promise.all(promises).then(function (dataURLS) {
      //console.log(dataURLS);
      let first = true;

      for (const ind in dataURLS) {

        if (dataURLS.hasOwnProperty(ind) && first) {

          //console.log("Page  " + ind);
          //    pdf.addImage(dataURLS[ind], 'PNG', 0, 0);

          var width = pdf.internal.pageSize.getWidth();
          var height = pdf.internal.pageSize.getHeight();
          height = ratio * width;
          pdf.addImage(dataURLS[ind], 'JPEG', 0, 0, 0, height + 10, '', 'FAST');
          //  pdf.addImage( dataURLS[ind], 'PNG',  0, 0, 0, 0,'','FAST'  );
          //  pdf.save('myPage.pdf');
          pdf.addPage();
        }
        first = false;
      }
      var pageCount = pdf.internal.getNumberOfPages();

      pdf.deletePage(pageCount)
      pdf.save('floorPlan.pdf');
      let data: any = new Blob([pdf.output('blob')], {
        type: 'application/pdf'

      });
      data.name = "Floor_Plan_NAPEC2020.pdf"
      uploadedFiles.push(data);
      mailsService1.findodel(6).subscribe(result => {
          composeMailComponent1.prepareEmailModel(result,new Contact(), "NAPEC",new Prospect(), uploadedFiles)
      });

    })





  }



  financeReporting(idClient: number) {
    this.factureService.findByParticipant(idClient).subscribe(result => {
      this.totalFactures = 0;
      this.totalPaiement = 0;
      this.solde = 0;
      let nbrFact = 0;
      result.forEach(facture => {
        if (!facture.annuler) {
          nbrFact++;





          this.devise = facture.devise;
          this.totalFactures += facture.montantttc;
          this.totalPaiement += facture.encaisser;
          this.solde += facture.reste;


        }
      });
    })
  }

  captureScreenAll() {

    this.deplacer('pop');
    var divHeight = $('.plancomplet').height();
    //console.log("divHeight",divHeight);
    
    var divWidth = $('.plancomplet').width();
    var ratio = divHeight / divWidth;
    const html2canvas = require('html2canvas');
    let mailsService1: MailsService = this.mailsService;
    let composeMailComponent1: ComposeMailComponent = this.composeMailComponent;
    let uploadedFiles = []
    // 297, 420 const pdf = new jsPDF('l', 'mm',  [1000, 1700] );580, 380
 //   const pdf = new jsPDF('l', 'mm', [600, 1800]
    const pdf = new jsPDF('l', 'mm', [930, 1400]);
    
    const promises = $('.plancomplet').map(function (index, element) {
      return new Promise(function (resolve, reject) {
        html2canvas(element, { allowTaint: false, logging: false })
          .then(function (canvas) {
            resolve(canvas.toDataURL("image/png"));
          })
          .catch(function (error) {
            reject('error in PDF page: ' + index);
          });
      });
    });

    Promise.all(promises).then(function (dataURLS) {
      //console.log(dataURLS);
      let first = true;

      for (const ind in dataURLS) {

        if (dataURLS.hasOwnProperty(ind) && first) {

          //console.log("Page  " + ind);
          //    pdf.addImage(dataURLS[ind], 'PNG', 0, 0);

          var width = pdf.internal.pageSize.getWidth();
          var height = pdf.internal.pageSize.getHeight();
          height = ratio * width;
          pdf.addImage(dataURLS[ind], 'JPEG', 0, 0, 0, height + 10, '', 'FAST');
          //  pdf.addImage( dataURLS[ind], 'PNG',  0, 0, 0, 0,'','FAST'  );
          //  pdf.save('myPage.pdf');
          pdf.addPage();
        }
        first = false;
      }
      var pageCount = pdf.internal.getNumberOfPages();

      pdf.deletePage(pageCount)
      pdf.save('floorPlan.pdf');
      let data: any = new Blob([pdf.output('blob')], {
        type: 'application/pdf'

      });
      data.name = "Floor_Plan_NAPEC2020.pdf"
      uploadedFiles.push(data);
      mailsService1.findodel(6).subscribe(result => {
        //   composeMailComponent1.prepareEmailModel(result,new Contact(), "NAPEC",new Prospect(), uploadedFiles)
      });

    })





  }
}
